import {VideoSlidesFilterModel} from "./video-slides-filter.model";

export class ForYouVideoSlidesFilter extends VideoSlidesFilterModel {
    get on(): boolean {
        return this.services.gamesFilter.currentAppliedFiltersIds.length < 1;
    }

    get shouldBeDisplayed(): boolean {
        return true;
    }

    async applyFilter(): Promise<void> {
        this.services.gamesFilter.clearFilters();
        console.log(Object.values(this.services.gamesFilter.filteredGamesMap))
    }
}